"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var mockData = [];
for (var i = 0; i < 20; i++) {
  mockData.push({
    key: i.toString(),
    title: "content".concat(i + 1),
    description: "description of content".concat(i + 1)
  });
}
var _default = exports.default = mockData;